import loginActions from './../loginActions';
import userModel from './../../store/models/user';

export default {
  state: {
      auth: {
          status: '',
          token: localStorage.getItem('token') || '',
          user: userModel.defaultUser(),
          notifications: null,
          defaultUser: userModel.defaultUser
      },
      breadcrumb: "UtterAccess"
  },
  mutations: {
      setBreadcrumb(state, value) {
          state.breadcrumb = value;
      },
      authRequest(state) {
          state.auth.status = 'loading';
      },
      authSuccess(state, params) {
          state.auth.status = 'success';
          state.auth.token = params.token;
          state.auth.user = params.user;
          state.auth.notifications = params.notifications;
      },
      authError(state) {
          state.auth.status = 'error';
      },
      logout(state) {
          state.auth.status = '';
          state.auth.token = '';
          state.auth.user = state.auth.defaultUser();
      }
  },
  actions: {
      login: loginActions.login,
      getUserData: loginActions.getUserData,
      logout: loginActions.logout,
      register: loginActions.register,
      breadcrumb: ({commit}, value) => {
          commit('setBreadcrumb', value);
      }
  },
  getters: {
      isLoggedIn: state => !!state.auth.token,
      authStatus: state => state.auth.status,
      displayName: (state) => {
          if (state.auth.token) {
              return state.auth.user.displayName;
          } else {
              return 'Guest';
          }
      },
      user: (state) => { return state.auth.user; },
      breadcrumb: (state) => { return state.breadcrumb; }
  },
  namespaced: false
};